export default __webpack_public_path__ + "static/media/closet5-before3-480w.a5b53319.png";